import { Modal, Typography } from 'antd'
import Card from 'components/card/Card'

import React from 'react'
import Button from 'components/button/Button'

interface ModalVoucherCancelProps {
  isOpen: boolean
  fetchStatus: 'loading' | 'success' | 'failed' | 'idle'
  onOpen: (isOpen: boolean) => void
  onSubmit: () => void
}

export default function ModalVoucherCancel(props: ModalVoucherCancelProps) {
  const isLoading = props.fetchStatus === 'loading'

  return (
    <Modal
      data-testid="modal_advanced_filter"
      centered
      onCancel={() => props.onOpen(false)}
      open={props.isOpen}
      footer={null}
      width={327}
    >
      <Card loading={isLoading} className="p-0">
        <Typography.Title level={3} className="mt-2 mb-4 text-base text-[#323539] text-center">
          Yakin Hentikan Voucher?
        </Typography.Title>
        <Typography.Paragraph className="my-2 text-sm text-[#323539] text-center">
          Voucher ini tidak dapat digunakan oleh pengguna setelah dihentikan.
        </Typography.Paragraph>
        <div className="xl:flex xl:gap-2">
          <Button
            data-testid="button-cancel"
            label="Kembali"
            variant="outline-primary-nohover"
            className="text-[#858C95] rounded-lg border-[#858C95] hover:bg-[#fff] w-full"
            onClick={() => props.onOpen(false)}
          />
          <Button
            data-testid="button-confirm"
            label="Ya, Hentikan"
            variant="solid-danger"
            className="rounded-lg w-full"
            onClick={props.onSubmit}
          />
        </div>
      </Card>
    </Modal>
  )
}
